// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavBarItem_navbarItem__3CGCL","selected":"NavBarItem_selected__gCWmT","disabled":"NavBarItem_disabled__EBUo9"};